import { render } from "./OtherParticipants.vue?vue&type=template&id=4a4d005f"
import script from "./OtherParticipants.vue?vue&type=script&lang=js"
export * from "./OtherParticipants.vue?vue&type=script&lang=js"

import "./OtherParticipants.vue?vue&type=style&index=0&id=4a4d005f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__